import React from "react";
import { cn } from "../../utils/cn";
import PageHeader from "./PageHeader";

const SIZE_CLASS = {
  md: "max-w-5xl",
  lg: "max-w-6xl",
  xl: "max-w-7xl",
  full: "max-w-none",
};

/**
 * Standard page container used across authenticated pages.
 * Use `header` when you need a custom header block; otherwise use title/subtitle/actions.
 */
export default function Page({
  size = "xl",
  className,
  title,
  subtitle,
  actions,
  header = null,
  children,
}) {
  return (
    <main
      className={cn(
        "mx-auto w-full min-w-0 px-4 py-6 sm:px-6 lg:px-9 lg:py-8",
        SIZE_CLASS[size] || SIZE_CLASS.xl,
        className
      )}
    >
      {header ? header : <PageHeader title={title} subtitle={subtitle} actions={actions} />}

      {children}
    </main>
  );
}
